/**
 * styles.ts
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { css } from '@emotion/react';

export const styles = {
  container: css({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    position: 'relative'
  }),

  wrapper: css({
    width: '100%',
    display: 'flex',
    position: 'relative',

    'button:first-of-type': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    },

    'button:last-of-type': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    }
  }),

  input: css({
    margin: 0,
    border: 0,
    outline: 'none',
    appearance: 'none',
    fontFamily: 'inherit',
    background: 'transparent',
    textAlign:  'center',

    width:        '100%',
    height:       '48px',
    padding:      '16px',
    fontSize:     '16px',
    lineHeight:   '24px',
    borderRadius: 0,
    fontWeight:   '500',

    '[type="number"]': {
      appearance: 'textfield',
    },

    borderTop: '1px solid rgb(0, 0, 0)',
    borderBottom: '1px solid rgb(0, 0, 0)',
    color:     'rgb(0, 0, 0)',
    backgroundColor: 'rgb(245, 245, 246)'
  }),

  button: css({
    outline:      'none',
    border:       'none',
    width:        '48px',
    height:       '48px',
    flexShrink:   0,
    display:      'flex',
    alignItems:  'center',
    justifyContent: 'center',
    borderRadius: 5,
    color:     'rgb(0, 0, 0)',
    backgroundColor: 'rgb(255, 255, 255)',
    boxShadow: '0 0 0 1px inset rgb(0, 0, 0)',
    transition: 'color .2s, background-color .2s, box-shadow .2s',

    '&:hover': {
      color: 'rgb(255, 255, 255)',
      backgroundColor: 'rgb(56, 59, 74)',
    }
  }),

  error: css({
    color: 'rgba(230, 103, 118, 1)',
    fontSize: '14px',
    fontWeight: '500'
  })
}